module.exports = __webpack_public_path__ + "img/dp2.6c103a0b.png";